import React from "react";
import styles from "./style.module.css";

const Header = () => {
  return (
    <div className={styles.main}>
      <h1 className={styles.heading}>Typing Test One 🚀⌨️ </h1>
      <p className={styles.subHeading}>The one minute typing challenge 🔥</p>
    </div>
  );
};

export default Header;
